import { render, staticRenderFns } from "./view-created.vue?vue&type=template&id=360749cf&"
import script from "./view-created.vue?vue&type=script&lang=js&"
export * from "./view-created.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports